





<div class="modal-signup modal-content" *ngIf="ShowList">
  <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form">

    <div class="card-header wh-header border-bottom">
      Add Tests
      <button type="button" class="close" data-dismiss="modal"
              (click)="activeModal.dismiss('Cross click')"
              aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <form class="form">
      <div class="modal-body overflow-x padding-top-0px">

        <section id="form-action-layouts">


          <div class="row justify-content-md-center">
            <div class="col-md-12 padding-left-0px">
              <div class="card margin-left-0px margin-right-0px">

                <div class="card-body margin-left-zero padding-left-0px padding-right-0px padding-top-0px padding-bottom-0px">
                 
                  <div class="px-6">



                    <div class="form-body">

                      <div class="row">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px padding-right-0px">
                          <div class="row">
                            <div class="col-md-4 text-align-right padding-left-0px margin-top-auto margin-bottom-auto">
                              <label class="margin-bottom-0px"> Code </label>
                            </div>
                            <div class="col-md-4 padding-left-0px">

                              <input type="text" class="form-control padding-left-0px">

                            </div>

                          </div>

                        </div>
                      </div>

                      <div class="row">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px padding-right-0px">
                          <div class="row">
                            <div class="col-md-4 text-align-right padding-left-0px margin-top-auto margin-bottom-auto">
                              <label class="margin-bottom-0px"> Name </label>
                            </div>
                            <div class="col-md-4 padding-left-0px">

                              <input type="text" class="form-control padding-left-0px">

                            </div>

                          </div>

                        </div>
                      </div>

                      <div class="row">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px padding-right-0px">
                          <div class="row">
                            <div class="col-md-4 text-align-right padding-left-0px margin-top-auto margin-bottom-auto">
                              <label class="margin-bottom-0px"> Short Name </label>
                            </div>
                            <div class="col-md-4 padding-left-0px">

                              <input type="text" class="form-control padding-left-0px">

                            </div>

                          </div>

                        </div>
                      </div>

                      <div class="row">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px padding-right-0px padding-top-0px">

                          <div class="row">
                            <div class="col-md-4 text-align-right padding-left-0px margin-top-auto margin-bottom-auto">
                              <label class="margin-bottom-0px"> Lab Department </label>
                            </div>
                            <div class="col-md-4 padding-left-0px">

                              <select class="form-control padding-left-0px">
                                <option value=" ">  </option>
                                <option value="All "> All </option>
                                <option value="Cardiology"> Cardiology </option>
                                <option value="Neurology"> Neurology </option>
                                <option value="Nephrology"> Nephrology </option>
                                <option value="Endocrinology"> Endocrinology </option>
                                <option value="Physiotherapy"> Physiotherapy </option>
                              </select>

                              <!--<input type="text" class="form-control padding-left-0px">-->
                            </div>

                          </div>

                        </div>
                      </div>

                      <div class="row">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px padding-right-0px">
                          <div class="row">
                            <div class="col-md-4 text-align-right padding-left-0px margin-top-auto margin-bottom-auto">
                              <label class="margin-bottom-0px"> Profile </label>
                            </div>
                            <div class="col-md-4 padding-left-0px">

                              <select class="form-control padding-left-0px">
                                <option value=" ">  </option>
                                <option value="Male "> Male </option>
                                <option value="Female "> Female </option>

                              </select>

                            </div>

                          </div>

                        </div>
                      </div>

                      <div class="row">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px padding-right-0px padding-top-0px">

                          <div class="row">
                            <div class="col-md-4 text-align-right padding-left-0px margin-top-auto margin-bottom-auto">
                              <label class="margin-bottom-0px"> Test Availability </label>
                            </div>
                            <div class="col-md-4 padding-left-0px">

                              <select class="form-control padding-left-0px">
                                <option value=" ">  </option>
                                <option value="All "> All </option>
                                <option value="Cardiology"> Cardiology </option>
                                <option value="Neurology"> Neurology </option>
                                <option value="Nephrology"> Nephrology </option>
                                <option value="Endocrinology"> Endocrinology </option>
                                <option value="Physiotherapy"> Physiotherapy </option>
                              </select>

                              <!--<input type="text" class="form-control padding-left-0px">-->
                            </div>

                          </div>

                        </div>
                      </div>

                      <div class="row">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px padding-right-0px">
                          <div class="row">
                            <div class="col-md-4 text-align-right padding-left-0px margin-top-auto margin-bottom-auto">
                              <label class="margin-bottom-0px"> Service Mapping </label>
                            </div>
                            <div class="col-md-4 padding-left-0px">

                              <input type="text" class="form-control padding-left-0px">

                            </div>

                          </div>

                        </div>
                      </div>

                      <div class="row">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px padding-right-0px padding-top-0px">

                          <div class="row">
                            <div class="col-md-4 text-align-right padding-left-0px margin-top-auto margin-bottom-auto">
                              <label class="margin-bottom-0px"> Test Type </label>
                            </div>
                            <div class="col-md-4 padding-left-0px">

                              <select class="form-control padding-left-0px">
                                <option value=" ">  </option>
                                <option value="All "> All </option>
                                <option value="Cardiology"> Cardiology </option>
                                <option value="Neurology"> Neurology </option>
                                <option value="Nephrology"> Nephrology </option>
                                <option value="Endocrinology"> Endocrinology </option>
                                <option value="Physiotherapy"> Physiotherapy </option>
                              </select>

                              <!--<input type="text" class="form-control padding-left-0px">-->
                            </div>

                          </div>

                        </div>
                      </div>

                      <div class="row">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px padding-right-0px">
                          <div class="row">
                            <div class="col-md-4 text-align-right padding-left-0px margin-top-auto margin-bottom-auto">
                              <label class="margin-bottom-0px"> Service Code </label>
                            </div>
                            <div class="col-md-4 padding-left-0px">

                              <input type="text" class="form-control padding-left-0px">

                            </div>

                          </div>

                        </div>
                      </div>
                    </div>










                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

      </div>


      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="ModalClose()">Back</button>
        <button type="submit" class="btn actions-btn-prime float-right font-size-13px">Save</button>

      </div>

    </form>
  </div>
</div>



